import React from "react";

const Facescan = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >

        <path className="u_fill"
              fill={fill}
            d="M27.406 2a2.01 2.01 0 0 1 2.024 2v3.12c0 .86-1.35.86-1.35 0V4a.673.673 0 0 0-.674-.667h-3.158c-.87 0-.87-1.333 0-1.333h3.158Zm0 21.693c.371 0 .675-.3.675-.666v-3.12c0-.86 1.35-.86 1.35 0v3.12c0 1.106-.905 2-2.025 2h-3.158c-.87 0-.87-1.334 0-1.334h3.158ZM8.15 25.027a2.01 2.01 0 0 1-2.025-2v-3.12c0-.86 1.35-.86 1.35 0v3.12c0 .366.303.666.675.666h3.157c.87 0 .87 1.334 0 1.334H8.15Zm3.157-21.694H8.15c-.372 0-.675.3-.675.667v3.12c0 .86-1.35.86-1.35 0V4c0-1.107.904-2 2.025-2h3.157c.87 0 .87 1.333 0 1.333Zm13.07 8.18H11.178c.816-3 3.711-5.113 6.855-4.993 2.962.107 5.573 2.173 6.343 4.993Zm4.379 2.667H6.8c-.87 0-.87-1.333 0-1.333h21.956c.87 0 .87 1.333 0 1.333Zm-17.543 1.333h13.13l-.425 1.54c-.945 2.794-2.611 6.634-6.14 6.64-3.529-.006-5.196-3.846-6.14-6.64l-.425-1.54ZM31.556 34H4v-1.153c0-2.187 1.532-4.074 3.69-4.554 1.323-.28 2.652-.453 3.988-.6 1.552-.173 2.787-1.373 2.976-2.906l.074-.62c.91.566 1.97.866 3.05.86a5.714 5.714 0 0 0 3.05-.86l.074.62c.189 1.533 1.423 2.733 2.975 2.906 1.336.147 2.672.32 3.988.6 2.159.48 3.69 2.367 3.69 4.554V34Z"
        />
    </svg>
);

export default Facescan;
